var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/mic"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.916 8.321.018-.018m.776-2.274.018-.018m1.858 1.649.018-.018m3.068 8.03 1.537 1.537m-5.765-1.153 5.596 4.418a2.445 2.445 0 0 0 3.244-.19m-4.228-8.84 4.418 5.596a2.445 2.445 0 0 1-.19 3.244m0 0L21.5 21.5M14.134 4.91a6.523 6.523 0 1 1-9.224 9.224 6.523 6.523 0 0 1 9.224-9.224Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.94e5ef014df01738fb28d2fd9d02a211.svg";
export { ForwardRef as ReactComponent };